export type MetricsTimeRangeKey = '5m' | '15m' | '30m' | '1h' | '6h';

export interface MetricsTimeRange {
  key: MetricsTimeRangeKey;
  label: string;
  shortLabel: string;
  durationMs: number;
}

export const METRICS_TIME_RANGES: MetricsTimeRange[] = [
  { key: '5m', label: 'Last 5 min', shortLabel: '5m', durationMs: 5 * 60 * 1000 },
  { key: '15m', label: 'Last 15 min', shortLabel: '15m', durationMs: 15 * 60 * 1000 },
  { key: '30m', label: 'Last 30 min', shortLabel: '30m', durationMs: 30 * 60 * 1000 },
  { key: '1h', label: 'Last 1 hour', shortLabel: '1h', durationMs: 60 * 60 * 1000 },
  { key: '6h', label: 'Last 6 hours', shortLabel: '6h', durationMs: 6 * 60 * 60 * 1000 },
];
